import { AppShellViewModel } from "../viewmodels/AppShellViewModel.js";
import { useSingleton } from "mvc-kit/react";
// src/modules/AppWrapper2/hooks/useAppList.ts
function useAppList() {
	const shellVM = useSingleton(AppShellViewModel);
	return {
		appList: shellVM.appList,
		currentApp: shellVM.currentApp,
		currentAppId: shellVM.state.currentAppId
	};
}
export { useAppList };

//# sourceMappingURL=useAppList.js.map